import React from "react";
import { Sparkle, X } from "@phosphor-icons/react";

/** Top bar of the chat panel, title, online dot, close button. */
export default function ChatHeader({ onClose }) {
  return (
    <div className="md-ai-head">
      <div className="md-ai-head-id">
        <span className="md-ai-head-dot" />
        <div>
          <div className="md-ai-head-title">
            <Sparkle size={14} weight="fill" /> MindDhara Assistant
          </div>
          <div className="md-ai-head-sub">Online · usually replies instantly</div>
        </div>
      </div>
      <button
        type="button"
        onClick={onClose}
        className="md-ai-close"
        aria-label="Close chat"
        data-testid="ai-chat-close"
      >
        <X size={16} weight="bold" />
      </button>
    </div>
  );
}
